var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"qidian",class:{'ycqd' : !_vm.showQQ}},[_c('div',{staticClass:"qq_qidian"}),(_vm.showQQ)?_c('div',{staticClass:"yincangBtn",on:{"click":_vm.yincangQQ}},[_vm._v("点击隐藏")]):_c('div',{staticClass:"xianshiBtn",on:{"click":_vm.xianshiQQ}},[_vm._v("在线客服")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }